import React, {useMemo, useState} from 'react';
import ConfirmationModal from "../ConfirmationModal";
import {useDispatch, useSelector} from "react-redux";
import {SELECT_QUANTITY_MODAL, updateModalRes} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import Quantity from "../../../components/UI/Quantity";
import {t} from "i18next";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {updateFlags} from "@arboxappv4/shared/src/redux/stepperSlice";

const SelectQuantity = (props) => {
    const { isOpen, onClose, target, max} = props;
    const [quantity, setQuantity] = useState(target?.quantity ?? 1);
    const dispatch = useDispatch()
    const {isMobile} = useScreenSize();
    const closeModal = (isSuccess = false) => {
        if(!isSuccess) dispatch(updateFlags({closedQuantityModal: true}))
        onClose()
    }

    const onConfirm = () => {
        dispatch(updateFlags({closedQuantityModal: false}))
        dispatch(updateModalRes({modalName: SELECT_QUANTITY_MODAL, res: {quantity, target}}))
    }

    return (
        <ConfirmationModal isOpen={isOpen}
                           onClose={closeModal}
                           onConfirm={onConfirm}
                           header={t('quantity-modal-header')}
                           explanation={<div style={{width: isMobile ? '100%' : '100px'}}><Quantity onChange={setQuantity} initSelection={quantity} min={target ? 0 : 1} max={max ?? null}/></div>}/>
    );
};

export default SelectQuantity;